export const WEB_DOCUMENT_ORIGINS = ['AB', 'BUS']

export const DOCUMENT_ORIGIN_LABELS = {
  AB: 'WEB',
}

const normalizeDocumentOrigin = origin =>
  String(origin || '')
    .trim()
    .toUpperCase()

export const isWebDocumentOrigin = origin =>
  WEB_DOCUMENT_ORIGINS.includes(normalizeDocumentOrigin(origin))

export const formatDocumentOrigin = origin => {
  const normalizedOrigin = normalizeDocumentOrigin(origin)

  return DOCUMENT_ORIGIN_LABELS[normalizedOrigin] || normalizedOrigin
}
